import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

const PREFIX = 'CollapseExpandButton';

const classes = {
  icon: `${PREFIX}-icon`
};

const StyledIconButton = styled(IconButton)({
  [`& .${classes.icon}`]: {
    float: 'right',
    verticalAlign: 'middle',
    cursor: 'pointer'
  }
});

interface CollapseExpandButtonProps {
  onClick: (e: any) => void;
  tooltipText: 'expand' | 'collapse';
}
const CollapseExpandButton = ({ onClick, tooltipText, ...rest }: CollapseExpandButtonProps) => {
  return (
    <StyledIconButton size="small" aria-label="properties" onClick={onClick} {...rest}>
      <Tooltip title={tooltipText}>
        {tooltipText === 'collapse' ? (
          <ExpandLess className={classes.icon} />
        ) : (
          <ExpandMore className={classes.icon} />
        )}
      </Tooltip>
    </StyledIconButton>
  );
};

export default CollapseExpandButton;
